import ar from './locale/ar.json';
import en from './locale/en.json';

export default {
  ar,
  en,
};
